// extracted by mini-css-extract-plugin
module.exports = {"anchor":"SupportBlock_anchor__2PK12","SupportBlock":"SupportBlock_SupportBlock__2cQmV","customForm":"SupportBlock_customForm__nJtkC"};